<template>
    <div class="accommodation">
  
      <div class="title-button">
  
        <h1>Tour Managers</h1>
  
        <router-link :to="{name:'create-tour-manager'}" class="button p-3" v-if="userRole == 1">
          New Tour Manager
        </router-link>
  
      </div>
  
      <div class="box">
  
        <form @submit.stop.prevent="doSearch" class="box__header form--inline">
          <input v-model="quickSearch" type="search" placeholder="Quick search">
          <button class="button button--small" type="submit">Search</button>
        </form>
  
        <vdtnet-table
          ref="table"
          :fields="fields"
          :opts="options"
          @edit="doAlertEdit"
          @delete="doAlertDelete"
          >
        </vdtnet-table>
  
      </div><!-- box -->
  
    </div>
  </template>
  
  <script>
  import 'datatables.net'
  import 'datatables.net-select'
  import VdtnetTable from 'vue-datatables-net'
  
  export default {
    name: 'TourManagerIndex',
    components: {
      VdtnetTable
    },
    data() {
      return {
        options: {
          ajax: {
            url: this.$api + 'tour-managers/table',
            'headers': {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          },
          responsive: false,
          processing: true,
          searching: true,
          searchDelay: 1500,
          destroy: true,
          ordering: true,
          lengthChange: true,
          serverSide: true,
          dom: 'rtlip',
          autoWidth: false,
          lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
          pageLength: 25,
        },
        fields: {
          firstname: { 
            label: 'Firstname',
            render: (d,t,r) => {
              return r.firstname
            }
          },
          lastname: { 
            label: 'Lastname',
            render : (data, type, row) => {
              return row.lastname
            }
          },
          email: { label: 'Email' },
          address: { label: 'Address' },
          actions: {
            sortable: false,
            label: ' ',
            render: (data, type, row) => {
              return `<a href="/tour-manager/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
            }
          },
          delete: {
            sortable: false,
            label: ' ',
            className: 'table-action',
            render: (data, type, row) => {
              if (this.userRole == 1) {
                return `<a href="/tour-managers/${ row.id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
              } else {
                return ''
              }
            }
          }
        },
        quickSearch: '',
        userRole: localStorage.getItem("user_role")
      }
    },
    methods: {
      doSearch() {
        this.$refs.table.search(this.quickSearch)
      },
      doAlertEdit(data) {
        this.$router.push({ name: 'edit-tour-manager', params: { id: data.id }})
      },
      doAlertDelete(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tour-managers/' + data.id + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.status) {
            this.$refs.table.reload()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      },
    }
  }
  
  </script>
  